module.exports = __webpack_public_path__ + "static/img/M_RTW.a2e81a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/M_RTW.jpg
// module id = oaxU
// module chunks = 1